var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ height: _vm.height }),attrs:{"card-holder":""}},[_c('div',{attrs:{"card-holder-inner":""}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }